<template>
  <!-- <card header-text="Users List"> -->
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong class="card-title mb-3">{{ 'Portfolio List - Return' }}</strong>
        </div>
        <div class="col-md-1">
          <!-- <download :tableId="'users'" :fileName="'users-list'"></download> -->
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <vue-tabs v-model="selSchemeTab" direction="horizontal" @tab-change="getTabData">
        <v-tab title="Latest">
          <div class="clear-fix"></div>
          <!-- new table XIRR-start -->
          <div class="row">
            <div class="col-md-11">
              <h4 class="font-weight-bold">XIRR</h4>
            </div>
            <div class="col-md-1">
              <download :tableId="'usersportfolioxirr'" :fileName="'user-portfolio-xirr'"></download>
            </div>
          </div>
          <div class="table-responsive mt15 app" v-dragscroll="true">
            <spinner v-if="isLoading"></spinner>
            <table id="usersportfolioxirr" class="table-xirr table table-sm first-td-padding table-bordered app-inner">
              <thead>
                <tr>
                  <th v-for="xirr in xirrValues" v-bind:key="'xirr' + xirr.title">{{ xirr.name }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in xirrData.portfolio" v-bind:key="'row' + index">
                  <td v-for="field in xirrValues" v-bind:key="field.title + index">
                    <span>
                      <span>{{ field.title === 'date' ? String(row[field.title]).indexOf("T") != -1 ?
                        getDateNew(fixDate(row[field.title])) : row[field.title] : row[field.title] }}</span>
                    </span>
                  </td>
                </tr>
              </tbody>
              <br />
              <tbody>
                <tr>
                  <td>{{ 'XIRR' }}</td>
                  <td>{{ xirrData.xirr != undefined ? getFixed(xirrData.xirr.xirr_value) : "" }} %</td>
                </tr>
                <tr>
                  <td>Latest date</td>
                  <td>{{ xirrData.xirr != undefined ? getDateNew(fixDate(xirrData.end_date)) : "" }}</td>
                </tr>
                <tr>
                  <td>First date</td>
                  <td>{{ xirrData.xirr != undefined ? getDateNew(fixDate(xirrData.start_date)) : "" }}</td>
                </tr>
                <tr>
                  <td>Period</td>
                  <td>{{ xirrData.durance != undefined ? xirrData.durance : "" }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- new table XIRR-end -->
          <!-- Display tables (Datewise values) -->
          <div class="row mt15">
            <div class="col-md-11">
              <h5 class="font-weight-bold">Display tables (Datewise values)</h5>
            </div>
            <div class="col-md-1">
              <download :tableId="'divearned'" :fileName="'date-wise-values'"></download>
            </div>
          </div>
          <!-- userStockPortfolioWeightedRelative -->
          <div class="table-responsive mt15 app" v-dragscroll="true">
            <table id="divearned" class="table table-sm first-td-padding table-bordered app-inner">
              <thead>
                <tr>
                  <th v-for="(row, index) in userPFolioDateWiseValuesTblFields" v-bind:key="'row' + index">{{
                    row.title }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <div v-for="(td, ind) in userStockPortfolioMonthlyData" :key="'tdfi' + ind"
                  v-if="td.transactions.length !== 0" style="display: contents;">
                  <tr v-for="(trans, cIdx) in td.transactions" v-if="td.transactions.length !== 0">
                    <!-- <div style="display: contents;"> -->
                    <td :key="'trans1' + ind + cIdx" v-if="trans.date !== undefined">
                      <span>{{ getDateNew(fixDate(trans.date)) }}</span>
                    </td>
                    <td :key="'trans2' + ind + cIdx" v-if="trans.total_purchases !== undefined">
                      <span>{{ trans.total_purchases == 0 ? "" : trans.total_purchases }}</span>
                    </td>
                    <td :key="'trans3' + ind + cIdx" v-if="trans.total_sales !== undefined">
                      <span>{{ trans.total_sales == 0 ? "" : trans.total_sales }}</span>
                    </td>
                    <td>
                      <span></span>
                    </td>
                    <!-- </div> -->
                  </tr>
                  <tr>
                    <td>
                      <span>{{ td.portfolio_e_date != null ? getDateNew(fixDate(td.portfolio_e_date)) :"" }}</span>
                    </td>
                    <td>
                      <span></span>
                    </td>
                    <td>
                      <span></span>
                    </td>
                    <td>
                      <span>{{ getFixed(td.portfolio_e) }}</span>
                    </td>
                  </tr>
                </div>
              </tbody>
            </table>
          </div>

          <!-- Display tables (Datewise values) -->

          <!-- Display tables (Sub-period return): START -->
          <div class="row mt15">
            <div class="col-md-11">
              <h5 class="font-weight-bold">Display tables (Sub-period return)</h5>
            </div>
            <div class="col-md-1">
              <download :tableId="'subperiodtbl'" :fileName="'sub-period return'"></download>
            </div>
          </div>
          <div class="table-responsive mt15 app" v-dragscroll="true">
            <table id="subperiodtbl" class="table table-sm first-td-padding table-bordered app-inner">
              <thead>
                <tr>
                  <th v-for="(row, index) in subPeriodReturnTblFields" v-bind:key="'row' + index">{{
                    row.title }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(td, ind) in userStockPortfolioMonthlyData" :key="'subpertdfi' + ind">
                  <td :key="'subper1' + ind">
                    <span>{{ td.portfolio_e_date != null ? getDateNew(fixDate(td.portfolio_e_date)) : "" }}</span>
                  </td>
                  <td :key="'subper2' + ind">
                    <span>{{ td.portfolio_b == 0 ? "" : getFixed(td.portfolio_b) }}</span>
                  </td>
                  <td :key="'subper3' + ind">
                    <span>{{ td.monthly_total_purchases == 0 ? "" : td.monthly_total_purchases }}</span>
                  </td>
                  <td :key="'subper4' + ind">
                    <span>{{ td.monthly_total_sales == 0 ? "0" : td.monthly_total_sales }}</span>
                  </td>
                  <td :key="'subper5' + ind">
                    <span>{{ td.portfolio_e == 0 ? "0" : getFixed(td.portfolio_e) }}</span>
                  </td>
                  <td :key="'subper6' + ind">
                    <span>{{ td.sub_period_return == 0 ? "" : getFixed(td.sub_period_return) }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Display tables (Sub-period return): END -->

          <!-- Display tables (Year wise): START -->
          <div class="row mt15">
            <div class="col-md-11">
              <h5 class="font-weight-bold">Display tables (Year wise)</h5>
            </div>
            <div class="col-md-1">
              <download :tableId="'twrryearwisetbl'" :fileName="'sub-period return'"></download>
            </div>
          </div>
          <div class="table-responsive mt15 app" v-dragscroll="true">
            <table id="twrryearwisetbl" class="table table-sm first-td-padding table-bordered app-inner">
              <thead>
                <tr>
                  <th v-for="(row, index) in twrrYearWiseTblFields" v-bind:key="'row' + index">{{
                    row.title }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(twrrTd, twrrIdx) in userStockPortfolioWeightedRelative.yearly_weighted_relative">
                  <td :key="'twrr1' + twrrIdx">
                    <span>{{ twrrTd.year }}</span>
                  </td>
                  <td :key="'twrr2' + twrrIdx">
                    <span>{{ getFixed(twrrTd.twrr) }}</span>
                  </td>
                  <td :key="'twrr3' + twrrIdx">
                    <span>{{ getFixed(twrrTd["twrr_%"]) }}</span>
                  </td>
                  <td :key="'twrr4' + twrrIdx">
                    <span>{{ getFixed(twrrTd.weighted) }}</span>
                  </td>
                </tr>
                <tr></tr>
              </tbody>
              <br>
              <tbody>
                <tr>
                  <td>Cumulative Wealth Relative</td>
                  <td>{{ getFixed(userStockPortfolioWeightedRelative.cumulative_weighted_relative) }}</td>
                </tr>
                <tr>
                  <td>No of years</td>
                  <td>{{ userStockPortfolioWeightedRelative.number_of_years }}</td>
                </tr>
                <tr>
                  <td>TWRR(Yearly)</td>
                  <td>{{ userStockPortfolioWeightedRelative.twrr_yearly }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Display tables (Year wise): END -->
        </v-tab>
        <v-tab title="Date-wise Return">
          <div class="clear-fix"></div>
          <!-- new table XIRR-start -->
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <v-select :options="filterDateData" :placeholder="'Select Date'" v-model="ddate"
                  @input="getSelDate($event)"></v-select>
              </div>
            </div>
            <div class="col-md-11" v-if="dateWiseReturnData.xirr != undefined">
              <h4 class="font-weight-bold">XIRR</h4>
            </div>
            <div class="col-md-1" v-if="dateWiseReturnData.xirr != undefined">
              <download :tableId="'usersportfolioxirr'" :fileName="'user-portfolio-xirr'"></download>
            </div>
          </div>
          <div class="table-responsive mt15 app" v-dragscroll="true" v-if="dateWiseReturnData.xirr != undefined">
            <spinner v-if="isLoading"></spinner>
            <table id="usersportfolioxirr" class="table-xirr table table-sm first-td-padding table-bordered app-inner">
              <!-- <thead>
                <tr>
                  <th v-for="xirr in xirrValues" v-bind:key="'xirr' + xirr.title">{{ xirr.name }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in xirrData.portfolio" v-bind:key="'row' + index">
                  <td v-for="field in xirrValues" v-bind:key="field.title + index">
                    <span>
                      <span>{{ row[field.title] }}</span>
                    </span>
                  </td>
                </tr>
              </tbody>
              <br />-->
              <tbody>
                <tr>
                  <td>{{ 'XIRR' }}</td>
                  <td>{{ dateWiseReturnData.xirr != undefined ? getFixed(dateWiseReturnData.xirr.xirr_value) : "" }} %
                  </td>
                </tr>
                <tr>
                  <td>Latest date</td>
                  <td>{{ dateWiseReturnData.xirr != undefined ? getDate(dateWiseReturnData.xirr.end_date.split("T")[0])
                    : "" }}</td>
                </tr>
                <tr>
                  <td>First date</td>
                  <td>{{ dateWiseReturnData.xirr != undefined ?
                    getDate(dateWiseReturnData.xirr.start_date.split("T")[0]) : "" }}</td>
                </tr>
                <tr>
                  <td>Period</td>
                  <td>{{ dateWiseReturnData.xirr != undefined ? dateWiseReturnData.xirr.durance : "" }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- new table XIRR-end -->

          <!-- Display tables (Sub-period return): START -->
          <div class="row mt15"
            v-if="dateWiseReturnData.sub_period_return != undefined && dateWiseReturnData.sub_period_return.length > 0">
            <div class="col-md-11">
              <h5 class="font-weight-bold">Display tables (Sub-period return)</h5>
            </div>
            <div class="col-md-1">
              <download :tableId="'subperdatewisetdfi'" :fileName="'sub-period return'"></download>
            </div>
          </div>
          <div class="table-responsive mt15 app" v-dragscroll="true"
            v-if="dateWiseReturnData.sub_period_return != undefined && dateWiseReturnData.sub_period_return.length > 0">
            <table id="subperdatewisetdfi" class="table table-sm first-td-padding table-bordered app-inner">
              <thead>
                <tr>
                  <th v-for="(row, index) in subPeriodReturnFields" v-bind:key="'row' + index">{{
                    row.title }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(td, ind) in dateWiseReturnData.sub_period_return" :key="'subperdatewisetdfi' + ind">
                  <td :key="'subperdatewise1' + ind">
                    <span>{{ td.portfolio_e_date != null ? getDateNew(fixDate(td.portfolio_e_date)) : "" }}</span>
                  </td>
                  <td :key="'subperdatewise2' + ind">
                    <span>{{ td.sub_period_return == 0 ? "" : getFixed(td.sub_period_return) }}</span>
                  </td>
                  <td :key="'subperdatewise3' + ind">
                    <span>{{ td.monthly_weighted_relative == 0 ? "" : getFixed(td.monthly_weighted_relative) }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Display tables (Sub-period return): END -->

          <!-- Display tables (Year wise): START -->
          <div class="row mt15"
            v-if="dateWiseReturnData.yearly_weighted_relative != undefined && dateWiseReturnData.yearly_weighted_relative.length > 0">
            <div class="col-md-11">
              <h5 class="font-weight-bold">Display tables (Year wise)</h5>
            </div>
            <div class="col-md-1">
              <download :tableId="'twrryearwisetbldate'" :fileName="'sub-period return'"></download>
            </div>
          </div>
          <div class="table-responsive mt15 app" v-dragscroll="true"
            v-if="dateWiseReturnData.yearly_weighted_relative != undefined && dateWiseReturnData.yearly_weighted_relative.length > 0">
            <table id="twrryearwisetbldate" class="table table-sm first-td-padding table-bordered app-inner">
              <thead>
                <tr>
                  <th v-for="(row, index) in twrrYearWiseTblFields" v-bind:key="'row' + index">{{
                    row.title }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <!-- TAB-2 -->
                <tr v-for="(twrrTd, twrrIdx) in dateWiseReturnData.yearly_weighted_relative">
                  <td :key="'twrr1' + twrrIdx">
                    <span>{{ twrrTd.year }}</span>
                  </td>
                  <td :key="'twrr2' + twrrIdx">
                    <span>{{ getFixed(twrrTd.twrr) }}</span>
                  </td>
                  <td :key="'twrr3' + twrrIdx">
                    <span>{{ getFixed(twrrTd["twrr_%"]) }}</span>
                  </td>
                  <td :key="'twrr4' + twrrIdx">
                    <span>{{ getFixed(twrrTd.weighted) }}</span>
                  </td>
                </tr>
                <tr></tr>
              </tbody>
              <br>
              <tbody>
                <tr>
                  <td>Cumulative Wealth Relative</td>
                  <td>{{ getFixed(dateWiseReturnData.cumulative_weighted_relative) }}</td>
                </tr>
                <tr>
                  <td>No of years</td>
                  <td>{{ dateWiseReturnData.number_of_years }}</td>
                </tr>
                <tr>
                  <td>TWRR(Yearly)</td>
                  <td>{{ dateWiseReturnData.twrr_yearly }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Display tables (Year wise): END -->
        </v-tab>
      </vue-tabs>


    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import spinner from "@/components/spinner";
import { commonMixins } from "../../../assets/mixins/common.js";
export default {
  components: { spinner },
  mixins: [commonMixins],
  name: "UserPortfolio",
  props: ["user"],
  created() {
    if (!this.$route.params.id) {
      this.$router.push({ name: "user-listing" });
    }
    console.log("Config ", process.env.API_URL);
    this.url = this.apiUrl;
    this.userId = this.$route.params.id;
    this.$route.query.page
      ? (this.pageToLoad = parseInt(this.$route.query.page))
      : (this.pageToLoad = "");
    this.url += this.pageToLoad;
    this.current_page = this.pageToLoad;
    console.log('=> Cur TAB: created: ', this.selSchemeTab, this.searchParams);
    let setIntTimeout = setTimeout(() => {
      clearTimeout(setIntTimeout);
      if (this.selSchemeTab === "Latest") {
        this.fetchData(this.searchParams);
        this.fetchXIRRData();
      }
    }, 1000);
  },
  watch: {
    reload() {
      this.fillTable();
    },
    $route(to, from) {
      this.pageToLoad = to.query.page;
      console.log("watch route", to.query);
      // this.fetchData(to.query)
    }
  },
  data() {
    return {
      //apiUrl: "frontend/getUserStockPortfolioMonthly",
      apiUrl: "frontend/mutual-funds/user_mutual_funds_portfolio_twrr/update",
      apiMode: true,
      isLoading: false,
      curDate: ("0" + (new Date().getDate())).slice(-2) + '-' + ("0" + (new Date().getMonth() + 1)).slice(-2) + '-' + new Date().getFullYear(),
      company: {},
      selSchemeTab: "",
      actions: [],
      xirrData: {},
      ddate: "",
      filterDateData: [],
      dateWiseReturnData: {},
      subPeriodReturnFields: [{ title: "Portfolio E Date", name: "portfolio_e_date", type: "date" }, { title: "Sub Period Return", name: "sub_period_return", type: "number" }, { title: "Monthly Weighted Relative", name: "monthly_weighted_relative", type: "number" }],
      xirrValues: [{ title: "date", name: "Date", type: "date" }, { title: "purchase", name: "Cash flows", type: "number" }],
      divEarnedTableFields: [
        {
          title: "year",
          name: "Year",
          isNumeric: true
        },
        {
          title: "no_of_share_held",
          name: "No. of Shares Held",
          isNumeric: true
        },
        {
          title: "dividend_per_share",
          name: "Dividend per share",
          isNumeric: true
        },
        { title: "dividend_earned", name: "Dividend Earned", isNumeric: true }
      ],
      userPFolioDateWiseValuesTblFields: [
        {
          name: "date",
          title: "Date",
          isNumeric: 0
        },
        {
          name: "total_purchases",
          title: "Purchase V",
          isNumeric: 1
        },
        {
          name: "total_sales",
          title: "Sale Value",
          isNumeric: 1
        },
        {
          name: "portfolio_e",
          title: "Portfolio E",
          isNumeric: 1
        },
      ],
      subPeriodReturnTblFields: [
        {
          name: "portfolio_e_date",
          title: "Date",
          isNumeric: 0
        },
        {
          name: "portfolio_b",
          title: "Portfolio B",
          isNumeric: 1
        },
        {
          name: "monthly_total_purchases",
          title: "Purchase",
          isNumeric: 1
        },
        {
          name: "monthly_total_sales",
          title: "Sale",
          isNumeric: 1
        },
        {
          name: "portfolio_e",
          title: "Portfolio E",
          isNumeric: 1
        },
        {
          name: "sub_period_return",
          title: "Sub-period Return",
          isNumeric: 1
        }
      ],
      subPeriodReturnTblFieldsDateWise: [
        {
          name: "portfolio_e_date",
          title: "Date",
          isNumeric: 0
        },
        {
          name: "sub_period_return",
          title: "Sub-period Return",
          isNumeric: 1
        },
        {
          name: "monthly_weighted_relative",
          title: "Monthly Weighted Relative",
          isNumeric: 1
        }
      ],
      twrrYearWiseTblFields: [
        {
          name: "year",
          title: "Year",
          isNumeric: 0
        },
        {
          name: "twrr",
          title: "TWRR",
          isNumeric: 1
        },
        {
          name: "twrr_%",
          title: "TWRR (%)",
          isNumeric: 1
        },
        {
          name: "weighted",
          title: "Wealth Relative",
          isNumeric: 1
        }
      ],
      searchParams: {},
      userStockPortfolioWeightedRelative: [],
      userStockPortfolioMonthlyData: [],
      userStockPortfolioTWRRData: [],
      url: "",
      current_page: 1,
      pageToLoad: 1,
      totalPages: 1,
      prevDisabled: 1,
      nextDisabled: 0,
      pages: [],
      userId: 0
    };
  },
  methods: {
    reset() {
      // window.location.reload();
      this.$router.push({ name: "user-listing" });
      this.searchParams = { userid: this.userId };
      this.pageToLoad = 1;
      this.current_page = 1;
      this.url = this.apiUrl + this.pageToLoad;
      this.fetchData(this.searchParams);
    },
    getSelDate(e) {
      console.log("Selected date", e);
      this.ddate = e;
      if (this.ddate != null) {
        this.fetchDateWiseReturnData();
      } else {
        this.dateWiseReturnData = {};
      }
      //this.getRawData();
    },
    getFilterDate() {

      let myself = this;
      //https://api.nobiasinvesting.com/frontend/filter-date?collection_name=twrr-xirr-return
      http.get(`mutual-funds/filter-date?collection_name=mutual-funds-twrr-xirr-return`, {}, function (error, response) {
        console.log("response", response);
        if (response.responseType === "success") {
          myself.filterDateData = response.date;
        }
      });
    },
    getTabData(tabIndex, newTab, oldTab) {
      console.log("TAB Change::: ", tabIndex, newTab.value, newTab.title);
      if (tabIndex === 0) {
        this.fetchData(this.searchParams);
        this.fetchXIRRData();

      } else if (tabIndex === 1) {
        //this.fetchData(this.searchParams);
        this.xirrData = {};
        this.userStockPortfolioMonthlyData = [];
        this.userStockPortfolioWeightedRelative = [];
        this.getFilterDate();
        //this.fetchDateWiseReturnData();
      }
      this.selSchemeTab = newTab.title;
    },
    fetchData(data) {
      if (this.url !== "") {
        console.log("url =====" + this.url + "========");
        let myself = this;
        //myself.isLoading = true;
        let params = data ? { userid: this.userId } : {};
        http.post(this.url, params, function (error, response) {
          for (let d in response) {
            if (Array.isArray(response[d]) && d !== 'yearly_weighted_relative') {
              myself.userStockPortfolioMonthlyData.push(response[d][0]);
            } else {
              //console.log("###### >>>", [d], response[d]);
              myself.userStockPortfolioWeightedRelative[d] = response[d];
            }
            //myself.isLoading = false;
          }
          //console.log('###### >>>', myself.userStockPortfolioWeightedRelative);
        });
      } else {
        //console.log("=====" + this.url + "========");

      }
    },
    fetchXIRRData() {
      let myself = this;
      myself.isLoading = true;
      //http.post("frontend/getUserStockPortfolio", { "userid": myself.userId }, function (error, response) {
      http.post("frontend/mutual-funds/user_mutual_funds_portfolio_xirr/update", { "userid": myself.userId }, function (error, response) {
        //console.log(">>> getUserStockPortfolio: ", response);
        // if (response.responseType === "success") {
        myself.xirrData = response;
        const resTimeUtl = setTimeout(function () {
          clearTimeout(resTimeUtl);
          myself.isLoading = false;
        }, 4000);
      });
    },
    fetchDateWiseReturnData() {
      let myself = this;
      myself.isLoading = true;
      //user_portfolio_twrr_or_xirr/get?user_id=166&date=2024-10-25
      //http.get(`user_portfolio_twrr_or_xirr/get?user_id=${myself.userId}&date=${myself.ddate}`, {}, function (error, response) {
      http.get(`frontend/mutual-funds/user_mutual_funds_portfolio_twrr_or_xirr/get?user_id=${myself.userId}&date=${myself.ddate}`, {}, function (error, response) {
        console.log("response", response);
        if (response.status === "success") {
          myself.dateWiseReturnData = response.data[0];
          //myself.xirrData.xirr = myself.dateWiseReturnData.xirr;
          const resTimeUtl = setTimeout(function () {
            clearTimeout(resTimeUtl);
            myself.isLoading = false;
          }, 2000);
        }
      });
    },
    prev() {
      this.pageToLoad = this.current_page - 1;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    goToPage(page) {
      this.pageToLoad = page;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    next() {
      console.log(this.$route.query);
      this.pageToLoad = this.current_page + 1;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    fillTable() {
      let url = this.apiUrl; //+"?a=1"
      if (this.pageToLoad != this.current_page) url += this.pageToLoad;
      this.url = url;
      this.fetchData(this.searchParams);
    },
    remove(index) {
      //this.fillableData.splice(index, 1);
    },
  }
};
</script>
<style>
.table td {
  padding: 5px 10px 5px 10px;
}

.table-xirr {
  width: auto;
}

.row {
  align-items: center;
}

.tab-content {
  margin-top: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/mutual-funds/acl/user-returns.vue